// extracted by mini-css-extract-plugin
export default {"backButton":"TopbarBackButton_backButton__ikx-B","backIcon":"TopbarBackButton_backIcon__pkYkm"};